/**
 * Error codes and user-facing messages. Shared with the browser bundle so the UI and the
 * SVG error card always show the same friendly text (never raw upstream errors).
 */

export type GraphErrorCode =
    | 'USERNAME_REQUIRED'
    | 'INVALID_USERNAME'
    | 'NOT_FOUND'
    | 'RATE_LIMITED'
    | 'UNAVAILABLE'
    | 'INTERNAL';

export const ERROR_MESSAGES: Record<GraphErrorCode, string> = {
    USERNAME_REQUIRED: 'Enter a GitHub username to generate a graph.',
    INVALID_USERNAME: "That doesn't look like a valid GitHub username.",
    NOT_FOUND: "We couldn't find a GitHub user with that name.",
    RATE_LIMITED: 'GitHub rate limit reached. Please try again in a few minutes.',
    UNAVAILABLE: 'GitHub is not responding right now. Please try again shortly.',
    INTERNAL: 'Something went wrong while generating the graph.',
};

export const HTTP_STATUS: Record<GraphErrorCode, number> = {
    USERNAME_REQUIRED: 400,
    INVALID_USERNAME: 400,
    NOT_FOUND: 404,
    RATE_LIMITED: 429,
    UNAVAILABLE: 503,
    INTERNAL: 500,
};

export class GraphError extends Error {
    constructor(
        public readonly code: GraphErrorCode,
        /** Internal detail for logs only, never sent to clients. */
        public readonly detail?: string,
    ) {
        super(ERROR_MESSAGES[code]);
        this.name = 'GraphError';
    }
}

export const isGraphErrorCode = (value: unknown): value is GraphErrorCode =>
    typeof value === 'string' && value in ERROR_MESSAGES;
